import { ShiftOptions } from './ICattlesData'

export interface IMilkingProcess {
	stats: IMilkingProcessStats
	deviations: IMilkingProcessDeviationItem[]
}

export interface IMilkingProcessStats {
	am: number | null
	pm: number | null
	night: number | null
	connect_avg: number | null //seconds
	milking_avg: number | null //seconds
}

export interface IMilkingProcessDeviationItem {
	type: MilkingProcessDeviationType
	count: number
}

export interface IMilkingProcessDeviationDetail {
	type: MilkingProcessDeviationType
	length_seconds: number | null
}

export interface IMilkingProcessDeviationResponse {
	count: number
	next: string | null
	previous: string | null
	results: IMilkingProcessDeviationEntry[] | null
}

export interface IMilkingProcessDeviationEntry {
	id: number
	timestamp: number
	milking_hall: string | null
	period: ShiftOptions
	milking_unit_num: number
	deviation: IMilkingProcessDeviationDetail
	video_url: string | null
	milker: string | null
	is_false: boolean
	is_false_by: number | null
	video_overlay?: IMilkingUnitOverlay | null
	milking_events?: IMilkingRoutineEvent[] | null
}

export type MilkingRoutineEventType =
	| 'scrubber'
	| 'pre_milking_treatment'
	| 'stimulation'
	| 'wiping'
	| 'connecting'
	| 'disconnecting'
	| 'disinfection'

export type MilkingRoutineEventStatus = 'done' | 'skipped'

export interface IMilkingRoutineEvent {
	type: MilkingRoutineEventType
	name: string
	timestamp: number | null
	status: MilkingRoutineEventStatus
	length_seconds?: number | null
}

export interface IMilkingUnitOverlayPoint {
	x: number
	y: number
}

export interface IMilkingUnitOverlayRect extends IMilkingUnitOverlayPoint {
	width: number
	height: number
}

// Координаты rect и text — в пикселях кадра камеры
export interface IMilkingUnitOverlay {
	rect: IMilkingUnitOverlayRect
	text: IMilkingUnitOverlayPoint | null
}

export type MilkingProcessDeviationType =
	| 'issue_pre_milking_treatment'
	| 'issue_stimulation'
	| 'issue_wiping'
	| 'issue_disinfection'
	| 'issue_early_connecting'
	| 'issue_later_connecting'
	| 'issue_no_reconnection'

export const deviationLabels: Record<MilkingProcessDeviationType, string> = {
	issue_pre_milking_treatment: 'Пропуск обработки вымени до доения',
	issue_disinfection: 'Пропуск дезинфекции вымени после доения',
	issue_stimulation: 'Пропуск стимуляции вымени',
	issue_no_reconnection:
		'Пропуск повторного подключения сбитого доильного аппарата',
	issue_later_connecting: 'Позднее подключение доильного аппарата',
	issue_early_connecting: 'Раннее подключение доильного аппарата',
	issue_wiping: 'Пропуск вытирания вымени',
}

export interface IMilkingProcessGraph {
	dots: IMilkingProcessGraphDot[]
	am_count: number | null
	pm_count: number | null
	night_count: number | null
}

export interface IMilkingProcessGraphDot {
	timestamp: number
	count: number | null
	status: MilkingProcessGraphStatus
}

export type MilkingProcessGraphStatus = 'ok' | 'camera_issue'

export interface IMilkingScheduleResponse {
	milk_hall: string
	am_allowed_deviation_seconds: number
	pm_allowed_deviation_seconds: number
	night_allowed_deviation_seconds: number
	am_period_start: string
	am_period_end: string
	pm_period_start: string
	pm_period_end: string
	night_period_start: string
	night_period_end: string
}

export interface IMilkingParlorName {
	id: number
	name: string
	milk_hall?: string | null
}

export interface IMilkingParlorNamesResponse {
	items: IMilkingParlorName[]
}

export type ParlorZoneType = 'post' | 'place'

export interface IMilkingParlorZone {
	id: number
	name: string
	milking_unit_num: number
	type: ParlorZoneType | ''
	default_deviation_type: string | null
}

export interface IMilkingParlorZonesResponse {
	items: IMilkingParlorZone[]
}

export interface IMilkingSchedulesResponse {
	items: IMilkingScheduleAssignment[]
	available_periods?: ShiftOptions[]
}

export interface IMilkingShift {
	id: number
	milking_parlor: number
	period: ShiftOptions
	start_time: string
	end_time: string
}

export interface IMilker {
	id: number
	full_name: string
	photo: string | null
}

export type IMilkersInfoResponse = IMilker[]

export interface IMilkingScheduleAssignment {
	id: number
	milker: number
	milker_name: string
	parlor: number
	parlor_name: string
	shift: number
	period: ShiftOptions
	work_date: string
	zones: number[]
}
